import { Box } from '@mui/material';
import React from 'react';
import { ListGroupItem } from "react-bootstrap";

/** The subset of the booking transaction response that this component displays */
interface InvoiceInformationBookingTransaction {
  transactionNumber?: string | number;
  createdOn?: string;
  booking?: {
    paymentMethodDescription?: string;
    location?: {
      locationName?: string;
    };
  };
}

interface InvoiceInformationContentProps {
  /** Empty (`{}`) until ServiceFeeApproval finishes loading the booking transaction */
  bookingTransaction?: InvoiceInformationBookingTransaction | null;
}

interface InvoiceInformation {
  label: string;
  value?: string | number;
}

const InvoiceInformationContent = (props: InvoiceInformationContentProps) => {
  const { bookingTransaction } = props;

  const informationArray: InvoiceInformation[] = [
    {
      label: "Invoice Number",
      value: bookingTransaction?.transactionNumber
    },
    {
      label: "Invoice Date",
      value: bookingTransaction?.createdOn
    },
    {
      label: "Location",
      value: bookingTransaction?.booking?.location?.locationName
    },
    {
      label: "Payment Method To Charge",
      value: bookingTransaction?.booking?.paymentMethodDescription
    },
  ]

  return (
    <Box mt={4}>
      <h3 style={{ float: "none" }} className={'ss-title-no-image'}>INVOICE INFORMATION</h3>
      <Box>
        {informationArray.map((information) => (
          <ListGroupItem key={information.label}>
            <h6 style={{
              fontSize: '1.15rem',
              textTransform: "capitalize"
            }}>{information.label}</h6>
            <small style={{
              fontSize: '0.875rem',
              color: '#6c757d'
            }}>{information.value}</small>
          </ListGroupItem>
        ))}
      </Box>
    </Box>
  )
}

export default InvoiceInformationContent;
